import { render, staticRenderFns } from "./Troops.vue?vue&type=template&id=3347a706&"
import script from "./Troops.vue?vue&type=script&lang=js&"
export * from "./Troops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports